import { Grid, Paper, Typography } from '@mui/material';
import { BarChart, BarPlot, ChartContainerPro } from '@mui/x-charts-pro';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import React, { useEffect, useState } from 'react'
import { getMonitorTimelineWeek } from '../../reducer/monitorPageSlice';
import { useSelector } from 'react-redux';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';


// const valueFormatter = (value) => `${value}`;

const valueFormatterY = (value => ``);

// const chartSetting = {
//     height: 300,
//     sx: {
//         [`.${axisClasses.left} .${axisClasses.label}`]: {
//             transform: 'translate(-20px, 0)',
//         },
//     },
// };

function DashboardAreaSummary(props) {
    const { level } = props;
    const weeklist = useSelector(getMonitorTimelineWeek);
    const woy = useSelector(getWeekOfYear);
    const [headerLabel, setHeaderLabel] = useState("");
    const [dataSet, setDataSet] = useState([]);
    const [countQualify, setCountQualify] = useState(0);
    const [countOpen, setCountOpen] = useState(0);

    useEffect(() => {
        const callAPI = async (areaLevel, level) => {
            // const year = weeklist[weeklist.length - 1].year;
            // const week = weeklist[weeklist.length - 1].week;
            // console.log(woy);
            const year = woy.year;
            const week = woy.week;

            const response = await fetch(`${process.env.REACT_APP_API_URL_SECURE}/d506-eoc/list${areaLevel}?year=${year}&disease_class=1`);
            const json = await response.json();

            const responseEoc = await fetch(`${process.env.REACT_APP_API_URL}/summary/get_eoc_count_by_week/${level}?year=${year}&week=${week}&limit=10`);
            const jsonEoc = await responseEoc.json();
            // console.log(jsonEoc);

            let listData = [];
            let weekCount = {};
            let limit = 10;

            let newWeekList = [];
            let count = 0
            for (let index = weeklist.length-1; index >= 0 && count < limit; index--) {
                const element = weeklist[index];
                if (count === 0) {
                    let current = `${woy.year}-${woy.week}`;
                    if (current === `${element.year}-${element.week}`) {
                        newWeekList.push({
                            woy: `${element.year}-${element.week}`,
                            week: element.week,
                            year: element.year
                        });
                        count++
                    }
                } else {
                    if (count < limit) {
                        newWeekList.push({
                            woy: `${element.year}-${element.week}`,
                            week: element.week,
                            year: element.year
                        });
                        count++
                    }   
                }
            }
            newWeekList.sort((a, b) => {
                let weekOfYearA = `${a.year}-${a.week < 10 ? '0'+a.week : a.week}`;
                let weekOfYearB = `${b.year}-${b.week < 10 ? '0'+b.week : b.week}`;
                // console.log(weekOfYearA);
                // console.log(weekOfYearB);
                return weekOfYearA.localeCompare(weekOfYearB);
                // return a.woy.localeCompare(b.woy);
            })

            // console.log(newWeekList);

            for (let index = 0; index < newWeekList.length; index++) {
                const element = newWeekList[index];
                weekCount[element.woy] = {
                    week: element.week,
                    year: element.year,
                    qualify: 0,
                    open: 0
                }
            }

            let keys = Object.keys(json);
            for (let index = 0; index < keys.length; index++) {
                const key = keys[index];
                const eocData = json[key]
                const week = eocData.eoc;
                for (let j = 0; j < week.length; j++) {
                    const element = week[j];
                    if (weekCount[element] !== undefined) {
                        weekCount[element]["qualify"]++;
                    }
                }
            }

            for (const key in jsonEoc) {
                if (Object.prototype.hasOwnProperty.call(jsonEoc, key)) {
                    const element = jsonEoc[key];
                    weekCount[`${element.year}-${element.week}`]["open"] = element.count;
                }
            }

            setCountQualify(weekCount[`${woy.year}-${woy.week}`].qualify);
            setCountOpen(weekCount[`${woy.year}-${woy.week}`].open);
            for (const key in weekCount) {
                if (Object.prototype.hasOwnProperty.call(weekCount, key)) {
                    const element = weekCount[key];
                    listData.push(element);
                }
            }
            setDataSet(listData);
        }
        if (level !== undefined && weeklist.length !== 0) {
            let areaLevel = "";
            if (level === "02") {
                setHeaderLabel("เขต");
                areaLevel = "region";
            } else if (level === "03") {
                setHeaderLabel("จังหวัด");
                areaLevel = "province";
            } else if (level === "04") {
                setHeaderLabel("อำเภอ");
                areaLevel = "amphur";
            }
            callAPI(areaLevel, level);
        }
    }, [level, weeklist, woy])


    return (
        // <ThemeProvider theme={customTheme}>
        <Paper sx={{
            // backgroundColor: 'red',
            width: '100%'
        }}>
            <Typography sx={{
                height: '50px',
                lineHeight: '50px',
                paddingLeft: '20px',
                fontSize: 24
            }}>
                {headerLabel}
            </Typography>
            <Grid container>
                <Grid item xs={6}>
                    <Typography sx={{
                        paddingLeft: '20px',
                        color: "#1151a4",
                        fontSize: 14
                    }}>เข้าเกณฑ์เปิด EOC</Typography>
                    <Typography sx={{
                        paddingLeft: '20px',
                        color: "#1151a4",
                        fontSize: 28
                    }}>{countQualify}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography sx={{
                        paddingRight: '20px',
                        color: "#cd6c4a",
                        textAlign: 'right',
                        fontSize: 14
                    }}>เปิด EOC</Typography>
                    <Typography sx={{
                        paddingRight: '20px',
                        color: "#cd6c4a",
                        textAlign: 'right',
                        fontSize: 28
                    }}>{countOpen}</Typography>
                </Grid>
            </Grid>
            <BarChart
                borderRadius={5}
                dataset={dataSet}
                xAxis={[{
                    scaleType: 'band',
                    dataKey: 'week',
                    valueFormatter: (code, context) => {
                        if (context.location === 'tick') {
                            return `${code}`;
                        } else {
                            return `สัปดาห์ที่ ${code}`
                        }
                    },
                    barGapRatio: 0
                }]}
                yAxis={[{ disableLine: true, disableTicks: true, valueFormatter: valueFormatterY }]}
                series={[
                    { dataKey: 'qualify', label: "เข้าเกณฑ์", color: '#1151a4', },
                    { dataKey: 'open', label: "เปิด EOC",color: '#cd6c4a'},
                    // { dataKey: 'newYork', valueFormatter },
                    // { dataKey: 'seoul', valueFormatter },
                ]}
                slotProps={{
                    legend: {hidden: true}
                }}
                height={200}
                sx={{
                    [`.${axisClasses.left} .${axisClasses.label}`]: {
                        transform: 'translate(-20px, 0)',
                    },
                }}
                margin={{
                    left: 20,
                    top: 10,
                    right: 20,
                    bottom: 30
                }}
            />
            {/* <ChartContainer
                
                width={500}
                height={300}
                dataset={dataset}
                series={[
                    { dataKey: 'london', valueFormatter,  },
                    { dataKey: 'paris', valueFormatter },
                    // { dataKey: 'newYork', valueFormatter },
                    // { dataKey: 'seoul', valueFormatter },
                ]}
                xAxis={[{ scaleType: 'band', dataKey: 'month' }]}
            >
                <BarPlot 
                    borderRadius={10}
                />
            </ChartContainer> */}
            {/* <Typography variant="h6"  style={{
                    textAlign: 'center'
                }}>{props.data.area_level_name}</Typography> */}
        </Paper>
        // </ThemeProvider>
        // <div className="box1" onClick={onclickZone}>
        //     <h2 style={{ margin: "20px 0 0 0" }}>เขต</h2>
        //     <div
        //         style={{
        //             display: "flex",
        //             justifyContent: "space-between",
        //             margin: "0px",
        //         }}
        //     >
        //         <div>
        //             <p style={{ margin: "0" }} className="ColorDashboardEOC-1"> เข้าเกณฑ์ที่เปิด EOC </p>
        //             <h1
        //                 style={{
        //                     marginTop: "0",
        //                     justifyContent: "flex-end",
        //                     display: "flex",

        //                 }}
        //                 className="ColorDashboardEOC-1"
        //             >
        //                 2
        //             </h1>
        //         </div>
        //         <div>
        //             <p style={{ margin: "0" }} className="ColorDashboardEOC-2"> เปิด EOC </p>
        //             <h1
        //                 style={{
        //                     marginTop: "0",
        //                     justifyContent: "flex-end",
        //                     display: "flex",

        //                 }}
        //                 className="ColorDashboardEOC-2"
        //             >
        //                 2
        //             </h1>
        //         </div>
        //     </div>
        //     <div
        //         style={{
        //             // backgroundColor: "black",
        //             justifyContent: "center",
        //             display: "flex",
        //             margin: "0",
        //         }}
        //     >
        //         <ResponsiveContainer width="95%" height={100}>
        //             <BarChart data={data}>
        //                 <CartesianGrid strokeDasharray="3 3" />
        //                 <XAxis dataKey="name" />
        //                 <Tooltip />
        //                 <Bar dataKey="จำนวนจังหวัดที่เข้าเกณฑ์เปิดEOC" fill="#1150A4" />
        //                 <Bar dataKey="จำนวนจังหวัดที่เปิดEOC" fill="#CE6D4A" />
        //             </BarChart>
        //         </ResponsiveContainer>
        //     </div>
        //     <h3 style={{ textAlign: "center", margin: "0px" }}>สัปดาห์</h3>
        // </div>
    )
}

export default DashboardAreaSummary
